module.exports = __webpack_public_path__ + "img/Woman-2.e3d8098c.svg";